/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './tooltip.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../../src/app/shared/components/tooltip/tooltip-container.directive';
import * as i4 from '../../../../../../src/app/shared/components/tooltip/tooltip.component';
const styles_TooltipComponent:any[] = [i0.styles];
export const RenderType_TooltipComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TooltipComponent,data:{}});
export function View_TooltipComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{tooltipContainer:0}),i1.ɵqud(402653184,2,
      {customComponentHost:0}),i1.ɵqud(402653184,3,{textHostElmRef:0}),(_l()(),i1.ɵted((null as any),
      ['\n	'])),(_l()(),i1.ɵeld(0,[[1,0]],(null as any),10,'div',[['class','my-tooltip-container']],
      [[2,'visible',(null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(278528,(null as any),0,i2.NgStyle,[i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer],{ngStyle:[0,'ngStyle']},(null as any)),i1.ɵpod({bottom:0,top:1,
          left:2,right:3,'max-width':4}),i1.ɵdid(16384,(null as any),0,i3.TooltipContainerDirective,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n		'])),(_l()(),i1.ɵeld(0,[[3,0],['textHost',1]],(null as any),0,'div',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n		'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          0,'span',([] as any[]),[[8,'className',0]],(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['\n		'])),(_l()(),i1.ɵeld(16777216,
          [[2,3],['customComponentHost',1]],(null as any),0,(null as any),(null as any),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n	']))],(_ck,_v) => {
    var _co:i4.TooltipComponent = _v.component;
    const currVal_1:any = _ck(_v,6,0,_co.bottom,_co.top,_co.left,_co.right,(_co.maxWidth + 'px'));
    _ck(_v,5,0,currVal_1);
  },(_ck,_v) => {
    var _co:i4.TooltipComponent = _v.component;
    const currVal_0:any = _co.isVisible;
    _ck(_v,4,0,currVal_0);
    const currVal_2:any = i1.ɵinlineInterpolate(1,'tooltip-caret position-',_co.position,
        '');
    _ck(_v,11,0,currVal_2);
  });
}
export function View_TooltipComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'my-tooltip-content',
      ([] as any[]),(null as any),[[(null as any),'mouseenter'],[(null as any),'mouseleave']],
      (_v,en,$event) => {
        var ad:boolean = true;
        if (('mouseenter' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onMouseEnter()) !== false);
          ad = (pd_0 && ad);
        }
        if (('mouseleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,1).onMouseLeave()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },View_TooltipComponent_0,RenderType_TooltipComponent)),i1.ɵdid(245760,(null as any),
      0,i4.TooltipComponent,['tooltipConfig',i1.Renderer,i1.Injector,i1.ComponentFactoryResolver],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TooltipComponentNgFactory:i1.ComponentFactory<i4.TooltipComponent> = i1.ɵccf('my-tooltip-content',
    i4.TooltipComponent,View_TooltipComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy90b29sdGlwL3Rvb2x0aXAuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy90b29sdGlwL3Rvb2x0aXAuY29tcG9uZW50LnRzIiwibmc6Ly8vaG9tZS9ub2RlL2FwcC9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3Rvb2x0aXAvdG9vbHRpcC5jb21wb25lbnQudHMuVG9vbHRpcENvbXBvbmVudC5odG1sIiwibmc6Ly8vaG9tZS9ub2RlL2FwcC9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3Rvb2x0aXAvdG9vbHRpcC5jb21wb25lbnQudHMuVG9vbHRpcENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuXHQ8ZGl2IGNsYXNzPVwibXktdG9vbHRpcC1jb250YWluZXJcIiBbY2xhc3MudmlzaWJsZV09XCJpc1Zpc2libGVcIiBbbmdTdHlsZV09XCJ7Ym90dG9tOiBib3R0b20sIHRvcDogdG9wLCBsZWZ0OiBsZWZ0LCByaWdodDogcmlnaHQsICdtYXgtd2lkdGgnOiBtYXhXaWR0aCArICdweCd9XCI+XG5cdFx0PGRpdiAjdGV4dEhvc3Q+PC9kaXY+XG5cdFx0PHNwYW4gY2xhc3M9XCJ0b29sdGlwLWNhcmV0IHBvc2l0aW9uLXt7cG9zaXRpb259fVwiPjwvc3Bhbj5cblx0XHQ8bmctY29udGFpbmVyICNjdXN0b21Db21wb25lbnRIb3N0PjwvbmctY29udGFpbmVyPlxuXHQ8L2Rpdj4iLCI8bXktdG9vbHRpcC1jb250ZW50PjwvbXktdG9vbHRpcC1jb250ZW50PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozt1RUNBQTtNQUFBLFVBQ0M7TUFBQTthQUFBO3FCQUFBLGdEQUE4RDtVQUFBLHNDQUE5RDtVQUFBLDJDQUE2SjtVQUFBLFdBQzVKO1VBQUE7TUFBcUIseUNBQ3JCO1VBQUE7VUFBQSxnQkFBeUQseUNBQ3pEO1VBQUE7VUFBQTtNQUFrRDs7SUFIVztJQUE5RCxXQUE4RCxTQUE5RDs7O0lBQWtDO0lBQWxDLFdBQWtDLFNBQWxDO0lBRU87UUFBQTtJQUFOLFlBQU0sU0FBTjs7OztvQkNIRjtNQUFBO01BQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBLCtEQUFBO01BQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/shared/components/tooltip/tooltip.component.ngfactory.ts